import axios from 'axios';

const createCisMemberForm = document.getElementById('create-cis-member');
const responseMessageElement = document.getElementById('create-cis-member-response');

if (createCisMemberForm) {
  createCisMemberForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    try {
      responseMessageElement.innerHTML = '<svg class="animate-spin h-20 w-20 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg> <div>Opretter bruger</div>';

      const formData = new FormData(createCisMemberForm);

      const createShopifyCustomerData = {
        firstName: formData.get('first_name'),
        lastName: formData.get('last_name'),
        email: formData.get('email'),
        phone: formData.get('phone'),
        taxExempt: false,
        accepts_marketing: true,
        smsMarketingConsent: {
          marketingState: 'UNSUBSCRIBED',
          marketingOptInLevel: 'UNKNOWN',
        },
        emailMarketingConsent: {
          marketingState: 'SUBSCRIBED',
          marketingOptInLevel: 'UNKNOWN',
        },
        fav_club: formData.get('club_search_input'),
        fav_store: formData.get('store_search_input'),
      };

      const createShopifyCustomerUrl = 'https://intersportapi.netlify.app/.netlify/functions/createCustomer';
      const shopifyResponse = await axios.post(createShopifyCustomerUrl, createShopifyCustomerData);

      const userErrors = shopifyResponse?.data?.customer?.data.customerCreate?.userErrors;
      if (userErrors && userErrors.length > 0) {
        const errorMessage = userErrors[0].message;
        responseMessageElement.innerHTML = `<div>Fejl ved oprettelse af Shopify kunde: ${errorMessage}</div>`;
      } else {
        responseMessageElement.innerHTML = '<div>Shopify kunde er oprettet</div>';
      }

      const createOpenLoyaltyMemberData = {
        firstName: formData.get('first_name'),
        lastName: formData.get('last_name'),
        email: formData.get('email'),
        phone: '+45' + formData.get('phone'),
        agreement1: true,
        agreement2: true,
        labels: {
          club: formData.get('club_search_input'),
          store: formData.get('store_search_input'),
        },
      };

      const createOpenLoyaltyMemberUrl = 'https://intersportapi.netlify.app/.netlify/functions/createMember';
      await axios.post(createOpenLoyaltyMemberUrl, createOpenLoyaltyMemberData);

      responseMessageElement.innerHTML += '<div>OpenLoyalty member er oprettet</div>';

      const updateShopifyCustomerTags = 'https://intersportapi.netlify.app/.netlify/functions/updateCustomerTags';
      await axios.post(updateShopifyCustomerTags, createShopifyCustomerData); 

      createCisMemberForm.reset();
    } catch (error) {
      console.log('🚀 ~ error:', error, error.response.data.message);
      if (error.response.data.message === "Cannot read properties of undefined (reading 'customerId')") {
        responseMessageElement.innerHTML += '<div>Open loyalty member kunne ikke oprettes</div>';
      } else {
        responseMessageElement.innerHTML += '<div>>Fejl ved oprettelse</div';
      }
    }
  });
}
